import { getDefaultSchedule, Schedule } from '../_lib/schedule';
import { ApiResource } from '../api-resource';
import { Activity } from '../activity/activity.model';
import { MessageChannel } from '../message-channel/message-channel.model';
import { Period } from '../period/period.model';
import { Organization } from '../organization/organization.model';
import { Course } from '../course/course.model';
import {
  BooleanField,
  DateField,
  Field,
  StringField,
} from '../../util/components/resource/resource-fields';
import { Endpoint } from '../api.decorators';
import { extractPeriodLabel } from '../../util/date';
import { OpenSpotsInformation } from '../application/lib/application.interfaces';
import { Absence, getDefaultAbsenceObject } from '../_lib/absence';
import { Location } from '../location/location.model';
import { ActivityRole } from '../activity/lib/activity.interfaces';

@Endpoint('camps', 'Camp')
export class Camp extends ApiResource<Camp> {
  @Field({
    default: getDefaultSchedule,
    includeFilter: false,
  })
  schedule!: Schedule;

  @BooleanField({
    default: () => false,
    label: $localize`Sleepover`,
  })
  sleepover!: boolean;

  @StringField({ label: $localize`Album URL` })
  albumUrl!: string;

  @Field({
    default: () => [],
    label: $localize`Required staff`,
    type: () => ActivityRole,
  })
  requiredStaff?: ActivityRole[];

  @StringField({ label: $localize`Album View URL` })
  albumViewUrl!: string;

  @Field({ type: () => Activity, readonly: true, includeFilter: false })
  activities!: Activity[];

  @Field({ type: () => Location, label: $localize`Location` })
  location!: Location;

  @Field({ includeFilter: false })
  channel!: MessageChannel;

  @Field({ label: $localize`Period` })
  period!: Period;

  @Field({ label: $localize`Hosted for`, type: () => Organization })
  hostedFor?: Organization;

  @DateField({ label: $localize`Start` })
  start!: Date;

  @DateField({ label: $localize`End` })
  end!: Date;

  @Field({ type: () => Course, readonly: true, includeFilter: false })
  courses!: Course[];

  @Field({ includeFilter: false })
  openSpotsInformation?: OpenSpotsInformation;

  @Field({ default: getDefaultAbsenceObject, includeFilter: false })
  absence!: Absence;

  get name() {
    return `${this.location?.name} ${extractPeriodLabel(this.schedule)}`;
  }
}
